/**
 * @flow
 * @relayHash 1cb806537f9fed995600b0043341864b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddSolicitationAllocatedDeliverableInput = {|
  solicitationId: string,
  deliverableId: string,
  contractorId: string,
  clientMutationId?: ?string,
|};
export type AllocateDeliverableMutationVariables = {|
  input: AddSolicitationAllocatedDeliverableInput
|};
export type AllocateDeliverableMutationResponse = {|
  +addSolicitationAllocatedDeliverable: ?{|
    +isUpdated: ?boolean,
    +solicitation: ?{|
      +id: string,
      +numberOfAllocatedDeliverables: ?number,
      +numberOfAllocatedContractedDeliverables: ?number,
    |},
  |}
|};
export type AllocateDeliverableMutation = {|
  variables: AllocateDeliverableMutationVariables,
  response: AllocateDeliverableMutationResponse,
|};
*/


/*
mutation AllocateDeliverableMutation(
  $input: AddSolicitationAllocatedDeliverableInput!
) {
  addSolicitationAllocatedDeliverable(input: $input) {
    isUpdated
    solicitation {
      id
      numberOfAllocatedDeliverables
      numberOfAllocatedContractedDeliverables
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddSolicitationAllocatedDeliverableInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addSolicitationAllocatedDeliverable",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddSolicitationAllocatedDeliverablePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isUpdated",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "solicitation",
        "storageKey": null,
        "args": null,
        "concreteType": "SolicitationNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "numberOfAllocatedDeliverables",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "numberOfAllocatedContractedDeliverables",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AllocateDeliverableMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AllocateDeliverableMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AllocateDeliverableMutation",
    "id": null,
    "text": "mutation AllocateDeliverableMutation(\n  $input: AddSolicitationAllocatedDeliverableInput!\n) {\n  addSolicitationAllocatedDeliverable(input: $input) {\n    isUpdated\n    solicitation {\n      id\n      numberOfAllocatedDeliverables\n      numberOfAllocatedContractedDeliverables\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'db0d3aca16d2fd869c9f43e8abb9bbc4';
module.exports = node;
